@for (item of chronologyData; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Cronologia {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.century) {
        <div>
          <dt>Secolo</dt>
          <dd>{{ item.century }}</dd>
        </div>
      }
      @if (item?.centuryFraction?.definition) {
        <div>
          <dt>Frazione di secolo</dt>
          <dd>{{ item.centuryFraction.definition }}</dd>
        </div>
      }
      @if (item?.from || item?.to) {
        <div class="sheet-facts-inline">
          @if (item?.from) {
            <div>
              <dt>Da</dt>
              <dd>
                {{ item.from }}
                @if (item?.validity_from?.definition) {
                  <span class="sheet-meta">({{ item.validity_from.definition }})</span>
                }
              </dd>
            </div>
          }
          @if (item?.to) {
            <div>
              <dt>A</dt>
              <dd>
                {{ item.to }}
                @if (item?.validity_to?.definition) {
                  <span class="sheet-meta">({{ item.validity_to.definition }})</span>
                }
              </dd>
            </div>
          }
        </div>
      }
      @if (item?.chronology_reason?.length > 0) {
        <div>
          <dt>Motivazione cronologica</dt>
          <dd>
            @for (el of item.chronology_reason; track el; let j = $index) {
              {{ el.definition }}@if (j + 1 < item.chronology_reason.length) {; }
            }
          </dd>
        </div>
      }
      @if (item?.otherDates?.length > 0) {
        <div>
          <dt>Altre datazioni</dt>
          <dd>
            @for (el of item.otherDates; track el; let j = $index) {
              {{ el.date }}@if (j + 1 < item.otherDates.length) {; }
            }
          </dd>
        </div>
      }
    </dl>
  </section>
}
